import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import util from './util'
import apps from './apps'
import app from './app'
import user from './user'

const rootReducer = combineReducers({
	app,
	apps,
	util,
	user,
	routing:routerReducer
})

export default rootReducer


// WEBPACK FOOTER //
// ./project/reducers/index.js